import { defineManifest } from '@template/modules'

export default defineManifest({
  id: 'dashboard',
  name: 'Dashboard',
  description: 'Painel principal com KPIs, metricas, status e atividade recente',
  version: '1.0.0',
  category: 'default',
  enabled: true,
  order: 1,
  dependencies: ['auth'],
  routes: ['/dashboard', '/dashboard/analytics', '/dashboard/alertas'],
  apiRoutes: ['/api/dashboard', '/api/health'],
  requiredTables: ['platform_metrics'],
  envVars: [],
  featureFlags: [],
  hooks: ['useHealthCheck'],
  components: ['DashboardClient', 'DashboardKPICards', 'DashboardCharts'],
  icon: 'LayoutGrid',
  path: '/dashboard',
  roles: [],
  showInSidebar: true,
  group: 'Principal',
  functions: [
    {
      id: 'dashboard-main',
      moduleId: 'dashboard',
      name: 'Visao Geral',
      subtitle: 'KPIs e metricas principais',
      path: '/dashboard',
      category: 'INDICADORES',
      enabled: true,
      order: 0,
      roles: [],
      tags: ['kpi', 'metricas'],
    },
    {
      id: 'dashboard-analytics',
      moduleId: 'dashboard',
      name: 'Analytics',
      subtitle: 'Analises detalhadas',
      path: '/dashboard/analytics',
      category: 'ANALISE',
      enabled: true,
      order: 1,
      roles: [],
      tags: ['graficos', 'analise'],
    },
    {
      id: 'dashboard-alerts',
      moduleId: 'dashboard',
      name: 'Alertas',
      subtitle: 'Notificacoes e watchlist',
      path: '/dashboard/alertas',
      category: 'CONTROLE',
      enabled: true,
      order: 2,
      roles: [],
      tags: ['alertas', 'notificacoes'],
    },
  ],
})
